export enum ChangeSetStatusEnum {
    Unknown = 0,
    PendingReview = 1,
    Reviewed = 2,
}

export const getChangeSetStatusName = (status: ChangeSetStatusEnum): string => {
    switch (status) {
        case ChangeSetStatusEnum.PendingReview:
            return 'Pending Review';
        case ChangeSetStatusEnum.Reviewed:
            return 'Reviewed';
        case ChangeSetStatusEnum.Unknown:
        default:
            return 'Unknown';
    }
};
